<template>
    <div>
        <div v-if="loading" class="loader-container">
            <div class="loader"></div> <!-- Stilizovani loader -->
        </div>
        <div class="row">
            <div class="col-md-24">
                <card>
                    <template slot="header">
                        <h5 class="card-category"></h5>
                        <h3 class="card-title">Praznici ({{ totalRecords }})</h3>
                    </template>
                    <div class="row">
                        <div class="col-md-3">
                            <!-- <card> -->
                                <h4 slot="header" class="card-title">Početak</h4>
                                <base-input>
                                    <el-date-picker type="datetime" placeholder="Početak" value-format="timestamp"
                                        v-model="filter.startStamp">
                                    </el-date-picker>
                                </base-input>
                            <!-- </card> -->
                        </div>
                        <div class="col-md-3">
                            <!-- <card> -->
                                <h4 slot="header" class="card-title">Kraj</h4>
                                <base-input>
                                    <el-date-picker type="datetime" placeholder="Kraj" value-format="timestamp"
                                        v-model="filter.endStamp">
                                    </el-date-picker>
                                </base-input>
                            <!-- </card> -->
                        </div>
                        <div class="col-md-3">
                            <!-- <card> -->
                                <h4 slot="header" class="card-title"> </h4>
                                <base-button class="mt-3" native-type="submit" type="primary"
                                    @click="getHolidays()">Pretraži</base-button>
                            <!-- </card> -->
                        </div>
                        <div class="col-md-3">
                            <!-- <card> -->
                                <h4 slot="header" class="card-title"> </h4>
                                <base-button class="mt-3" native-type="submit" type="primary"
                                    @click="holiday = {}; editHoliday = true">Novi praznik</base-button>
                            <!-- </card> -->
                        </div>
                    </div>

                    <el-table :data="holidays" v-loading="ticketsLoading">

                        <el-table-column min-width="130" prop="name" label="Ime">
                            <template slot-scope="scope">
                                <span>{{ scope.row.name }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="130" prop="start" label="Datum">
                            <template slot-scope="scope">
                                <span>{{ (new Date(scope.row.startLong)).toLocaleString("de-DE") }} - {{ (new Date(scope.row.endLong)).toLocaleString("de-DE") }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="130" prop="message" label="Poruka">
                            <template slot-scope="scope">
                                <span>{{ scope.row.message }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="130" prop="paymentType" label="Placanje">
                            <template slot-scope="scope">
                                <span v-if="scope.row.paymentType === 0">NE PLACA SE</span>
                                <span v-if="scope.row.paymentType === 1">SLEDECI RADNI DAN</span>
                            </template>
                        </el-table-column>

                        

                        <el-table-column min-width="100" header-align="right" align="right" label="Actions">
                            <div slot-scope="scope" class="text-right table-actions">

                                <base-button :type="'success'" class="btn-link"
                                    @click="holiday = scope.row; editHoliday = true">
                                    Izmeni
                                </base-button>

                            </div>
                        </el-table-column>

                    </el-table>
                    <div class="block">
                        <span class="demonstration">Ukupno stranica: {{ totalPages }}</span>
                        <base-pagination class="pagination-no-border" v-model="page"
                            :per-page="max" :total="totalRecords" @input="changeP">
                        </base-pagination>
                    </div>
                </card>
            </div>


        </div>
        
        <modal :show.sync="editHoliday" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link"
                @click="editHoliday = false; holiday = {}">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>


            <card class="stacked-form" title="Praznik">
                <form @submit.prevent>
                    <div>
                        <div class="row">
                            <div class="col-md-3">
                                <base-input label="Ime" type="text" v-model="holiday.name" placeholder="Ime"></base-input>
                            </div>
                            <div class="col-md-3">
                                <base-input label="Pocetak">
                                    <el-date-picker type="datetime" placeholder="Pocetak" value-format="timestamp"
                                        v-model="holiday.startLong">
                                    </el-date-picker>
                                </base-input>
                            </div>

                            <div class="col-md-3">
                                <base-input label="Kraj">
                                    <el-date-picker type="datetime" placeholder="Kraj" value-format="timestamp"
                                        v-model="holiday.endLong">
                                    </el-date-picker>
                                </base-input>
                            </div>

                            <div class="col-md-3">
                                <base-input label="Placanje">
                                    <el-select v-model="holiday.paymentType" class="select-primary"
                                            name="paymentType">
                                        <el-option v-for="t in paymentTypes" class="select-primary" :label="t.name" :value="t.id"
                                            :key="t.id"></el-option>
                                    </el-select>
                                </base-input>
                            </div>
                            
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <base-input label="SMS" type="textarea"  >
                                    <textarea
                                    
                                        placeholder="SMS"
                                        v-model="holiday.message"
                                        style="height: 300px; width: 100%"
                                        >
                                        </textarea>
                                    </base-input>
                            </div>
                        </div>

                    </div>
                </form>

            </card>


            <base-button class="mt-3" native-type="submit" style="margin-left: 20px;" type="primary"
                @click="saveHoliday()">Sačuvaj</base-button>
            <base-button class="mt-3" native-type="submit" style="margin-left: 20px;" type="danger"
                @click="editHoliday = false; holiday = {}">Odustani</base-button>

        </modal>
        
    </div>
</template>
<script>
import { TabPane, Tabs, Collapse, CollapseItem, BasePagination } from 'src/components';
import { Table, TableColumn, TimeSelect, DatePicker, Select, Option, Pagination } from 'element-ui';
import { BaseCheckbox, BaseProgress, RouteBreadCrumb } from 'src/components';
import axios from '@/util/axiosinstance'

import swal from 'sweetalert2';
import { BaseNav, Modal } from '@/components';
import htmlDocx from 'html-docx-js';
import { saveAs } from 'file-saver';

const paymentTypes = [
    { id: 0, name: "NE PLACA SE" }
    // { id: 1, name: "SLEDECI RADNI DAN" }
]

export default {
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [DatePicker.name]: DatePicker,
        [TimeSelect.name]: TimeSelect,
        [Option.name]: Option,
        [Select.name]: Select,
        TabPane,
        Tabs,
        Collapse,
        CollapseItem,
        Modal,
        BasePagination
    },
    mounted() {
        this.getHolidays()
    },
    data() {
        const now = new Date();

        // Postavljanje startStamp na 00:00:00 danas
        const startStamp = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0).getTime();

        // Postavljanje endStamp na 23:59:59 danas
        const endStamp = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59).getTime();

        return {
            paymentTypes,
            url: 'https://budva.scancar.org:8443/kuca',
            ticketsLoading: false,
            loading: false,
            holidays: [],
            filter: {
                startStamp: startStamp,
                endStamp: endStamp
            },
            holiday: {},
            editHoliday: false,
            page: 1,
            max: 10,
            totalRecords: 0,
            totalPages: 0,
            sortField: "start",
            sortOrder: "descending"
        };
    },
    methods: {
        handleClear() {
            // Postavi željenu vrednost kada se izbriše selekcija
            this.filter.status = null; // ili -1
        },
        changeP(item){
            this.page = item
            this.getHolidays()
        },
        getHolidays() {
            this.ticketsLoading = true
            const f = this.filter
            f.page = this.page
            f.max = this.max
            f.sortField = this.sortField
            f.sortOrder = this.sortOrder
            axios.post(this.url + '/settings/getHolidaysSms', f).then(result => {
                this.ticketsLoading = false

                if (result.data.result === 'ok') {
                    this.holidays = result.data.holidays
                    this.totalPages = result.data.totalPages
                    this.totalRecords = result.data.totalRecords
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        saveHoliday() {
            this.ticketsLoading = true
            axios.post(this.url + '/settings/saveHolidaySms', this.holiday).then(result => {
                this.ticketsLoading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            "Sacuvano",
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.holiday = {}
                    this.editHoliday = false
                    this.getHolidays()
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        navigateToPage() {
            this.$router.push({ name: 'Administration' });
        },
        deletePrompt() {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });
            swalWithBootstrapButtons4
                .fire({
                    title: "Da li ste sigurni da želite da parking mesto \"" + this.parkingSpace.number + "\"?",
                    text: ``,
                    confirmButtonText: "Da, obriši!",
                    cancelButtonText: "NE",
                    showCancelButton: true,
                })
                .then((result) => {
                    if (result.value) {
                        this.deleteParkingSpace()
                        // const swalWithBootstrapButtons5 = swal.mixin({
                        //     customClass: {
                        //     confirmButton: "btn btn-success btn-fill",
                        //     },
                        //     buttonsStyling: false,
                        // });
                        // swalWithBootstrapButtons5.fire({
                        //     title: "Deleted!",
                        //     text: "Your file has been deleted.",
                        // });
                    }
                });
        },
        saveTicketPrompt() {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });

            swalWithBootstrapButtons4
                .fire({
                    title: "Molimo vas unesite komentar za ovu promenu.",
                    html: `<textarea id="comment" class="swal2-textarea" placeholder="Komentar" style="width: 100%; height: 100px;"></textarea>`,
                    confirmButtonText: "Sačuvaj",
                    cancelButtonText: "Odustani",
                    showCancelButton: true,
                    preConfirm: () => {
                        const comment = document.getElementById("comment").value;
                        // if (!comment.trim()) {
                        //     Swal.showValidationMessage("Molimo unesite komentar pre nego što nastavite!");
                        // }
                        return comment;
                    },
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        const comment = result.value; // Dohvaćen komentar
                        console.log("Komentar:", comment); // Možete proslediti komentar funkciji
                        // this.deleteParkingSpace(comment);
                        this.ticket.comment = comment;
                        this.saveTicket()
                    }
                });
        }

    }
};
</script>
<style lang="scss">
/* Pozadina modala */
.custom-modal {
    background-color: rgba(0, 0, 0, 0.8);
}

.custom-modal-content {
    background-color: #3b3b5c;
    /* Tamna pozadina */
    color: #ffffff;
    /* Svetli tekst */
    border-radius: 8px;
    max-width: 800px;
    width: 800px;
}

/* Stil za telo modala */
.custom-modal-body {
    padding: 20px;
}

/* Stil za tabelu unutar modala */
.custom-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #2c2c3e;
    /* Tamna pozadina tabele */
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table th {
    background-color: #3c3c4f;
    /* Tamna pozadina za zaglavlje */
    color: #ffffff;
    /* Beli tekst */
    padding: 10px;
    text-align: left;
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.custom-table td {
    padding: 10px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table tr:hover {
    background-color: rgba(255, 255, 255, 0.1);
    /* Istaknuta boja za hover */
}


.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    /* Visina loadera */
    background-color: rgba(255, 255, 255, 0.7);
    /* Providna pozadina */
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    /* Iznad ostalog sadržaja */
}

.loader {
    border: 8px solid #f3f3f3;
    /* Svetla boja */
    border-top: 8px solid #3498db;
    /* Boja animacije */
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>